import React, { useState } from 'react';
import {
    makeStyles,
    TextField,
    Button,
    Grid,
    Typography,
  } from '@material-ui/core/';
import emailjs from 'emailjs-com';
import SendIcon from '@material-ui/icons/Send';

const useStyles = makeStyles(() => ({
    form: {
      width: '100%',
    },
    button: {
      textAlign: 'center',
    },
  }));

function ContactForm() {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [message, setMessage] = useState('');

  const classes = useStyles();

  function handleFirstNameChange(e) {
    setFirstName(e.target.value);
  }

  function handleLastNameChange(e) {
    setLastName(e.target.value);
  }

  function handleEmailChange(e) {
    setEmail(e.target.value);
  }

  function handlePhoneChange(e) {
    setPhone(e.target.value);
  }

  function handleMessageChange(e) {
    setMessage(e.target.value);
  }

  function sendEmail(e) {
      e.preventDefault();
      const userId = 'user_2tcI58rhQCYOSkCht2GtA'
  
      emailjs.sendForm('service_veaclm8', 'template_hg7o5wj', e.target, userId);

      e.target.reset();
      setFirstName('');
      setLastName('');
      setEmail('');
      setPhone('');
      setMessage('');
    }

    return (
        <form onSubmit={sendEmail} className={classes.form}>
        <input type="hidden" name="subject" value='Dolní Věstonice - ubytování' />
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                autoComplete="fname"
                name="firstName"
                variant="outlined"
                required
                fullWidth
                id="firstName"
                label="Jméno"
                value={firstName}
                onChange={handleFirstNameChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                variant="outlined"
                required
                fullWidth
                id="lastName"
                label="Příjmení"
                name="lastName"
                autoComplete="lname"
                value={lastName}
                onChange={handleLastNameChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                variant="outlined"
                required
                fullWidth
                id="email"
                label="Email"
                name="email"
                autoComplete="email"
                value={email}
                onChange={handleEmailChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                variant="outlined"
                required
                fullWidth
                name="number"
                label="Telefonní číslo"
                type="number"
                id="number"
                autoComplete="number"
                value={phone}
                onChange={handlePhoneChange}
              />
            </Grid>
            <Typography className={classes.form} align='center' variant='subtitle2' color='textSecondary'>
              Pro urychlení odpovědi doporučujeme do zprávy napsat termín a počet osob.
            </Typography>
            <Grid item xs={12} sm={12}>
              <TextField
                id="outlined-textarea"
                type="textarea"
                name="message"
                label="Vaše zpráva"
                multiline
                variant="outlined"
                required
                fullWidth
                autoComplete='message'
                value={message}
                onChange={handleMessageChange}
              />
              <Typography size='small' align='right' variant='subtitle2' color='textSecondary' >*povinná pole</Typography>
            </Grid>
            <Grid className={classes.button} item xs={12}>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                endIcon={<SendIcon />}
              >
                Odeslat
              </Button>
            </Grid>
          </Grid>
        </form>
      );
}

export default ContactForm;